import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { connect } from 'react-redux';
import { selectType } from '../../ReduxStorage/location/selectors';
import { HotConnectedOLTopBar as OLTopBar } from '../containers/OLTopBar/index';
import { LoadablePortalCoursePage } from './PortalCoursePage/LoadablePortalCoursePage';
import { LoadablePortalInstitutionPage } from './PortalInstitutionPage/LoadablePortalInstitutionPage';
import { LoadablePortalQualificationPage } from './PortalQualificationPage/LoadablePortalQualificationPage';
import { LoadablePortalSubscriptionPage } from './PortalSubscriptionPage/LoadablePortalSubscriptionPage';
import {
  ROUTE_COURSE_PAGE,
  ROUTE_INSTITUTION_HOMEPAGE,
  ROUTE_INSTITUTION_QUALIFICATION_PAGE,
  ROUTE_INSTITUTION_SUBSCRIPTIONS_PAGE,
} from '../../ReduxStorage/routeActions';
import { PORTAL_VIEW } from './constants';
import { AccessRestrictedPage } from './PortalInstitutionPage/AccessRestrictedPage';
import { ConnectedLoginPage } from './PortalInstitutionPage/LoginPage';
import { selectWindowSize } from '../../ReduxStorage/WindowSize/selectors';
import { WindowSizePropType } from '../../CustomPropTypes/BrowserPropTypes';
import { PortalInstitutionPropType } from '../containers/WasabiPage/institutions/InstitutionListPage';
import { selectCurrentInstitutionPath } from '../../ReduxStorage/Institutions/CurrentInstitutionPath/selectors';
import './PortalRoot.scss';
import { selectCurrentInstitutionEnrolmentPortalViewAccess } from '../../ReduxStorage/InstitutionEnrolments/selectors';
import { LoginSignupContext } from '../components/LoginSignup/context';
import { selectCurrentPortal } from '../../ReduxStorage/Portal/selectors';

const DEFAULT_CTA_COLOR = '#d3277e'; // ol-colours-cta-pink

class PortalPage extends React.PureComponent {
  static propTypes = {
    routeType: PropTypes.string.isRequired,
    institutionData: PortalInstitutionPropType,
    ctaColor: PropTypes.string.isRequired,
    // no way to render 'hidden' as that is handled by the Access Forbidden page
    view: PropTypes.oneOf([
      PORTAL_VIEW.LANDING,
      PORTAL_VIEW.LOGIN,
      PORTAL_VIEW.RESTRICTED,
    ]),
    windowSize: WindowSizePropType.isRequired,
  };

  static defaultProps = {
    view: null,
    institutionData: null,
  };

  renderPortalPage = () => {
    const { view, windowSize, institutionData, routeType } = this.props;
    const portalInstitution = institutionData;

    if (
      routeType === ROUTE_INSTITUTION_HOMEPAGE ||
      routeType === ROUTE_INSTITUTION_QUALIFICATION_PAGE ||
      routeType === ROUTE_INSTITUTION_SUBSCRIPTIONS_PAGE
    ) {
      if (!institutionData) {
        return null; // Init hasn't happened yet
      }

      if (view === PORTAL_VIEW.RESTRICTED) {
        return <AccessRestrictedPage {...{ windowSize, portalInstitution }} />;
      } else if (view === PORTAL_VIEW.LOGIN) {
        return <ConnectedLoginPage {...{ windowSize, portalInstitution }} />;
      }
    }

    switch (routeType) {
      case ROUTE_COURSE_PAGE:
        return <LoadablePortalCoursePage />;
      case ROUTE_INSTITUTION_HOMEPAGE:
        return <LoadablePortalInstitutionPage />;
      case ROUTE_INSTITUTION_QUALIFICATION_PAGE:
        return <LoadablePortalQualificationPage />;
      case ROUTE_INSTITUTION_SUBSCRIPTIONS_PAGE:
        return <LoadablePortalSubscriptionPage />;
      default:
        return null;
    }
  };

  render() {
    const { ctaColor } = this.props;

    return (
      <portal-page>
        <LoginSignupContext.Provider value={{ ctaColor }}>
          <OLTopBar fixed={false} reloadOnLogin />
          {this.renderPortalPage()}
        </LoginSignupContext.Provider>
      </portal-page>
    );
  }
}

const mapStateToProps = (state) => {
  const institutionPath = selectCurrentInstitutionPath(state);
  const view = selectCurrentInstitutionEnrolmentPortalViewAccess(state);
  const windowSize = selectWindowSize(state);
  const institutionData = state.Portal.get(institutionPath);
  const portalInstitution = selectCurrentPortal(state);

  let ctaColor = DEFAULT_CTA_COLOR;
  if (portalInstitution) {
    // course landing pages
    ctaColor = portalInstitution.getIn(['themeData', 'cta-color'], ctaColor);
  } else if (institutionData) {
    // all other pages that still load data via DOM
    ctaColor = institutionData.getIn(['themeData', 'cta-color'], ctaColor);
  }

  return {
    routeType: selectType(state),
    view,
    windowSize,
    institutionData,
    ctaColor,
  };
};

export const HotConnectedPortalPage = hot(connect(mapStateToProps)(PortalPage));
